import React from 'react';

import styled from 'styled-components';

import { Show } from '../../show';

import { exercisePropTypes, HIGHLIGHT_ERROR, HIGHLIGHT_NORMAL, HIGHLIGHT_SUCCESS } from '../../../constants/exercise';
import RadioOption from '../../radio-group/radio-option';
import ChoiceChip from '../../choice-chip';
import { getCharByElementPosition } from '../../../lib/exercise';
import MathContent from '../../math-content';
import FluidContainer from '../../layouts/components/fluid-container';
import Spacer from '../../spacer';

const RadioOptionBox = styled.div`
    width: fit-content;
`;

const SingleAnswerContainer = styled.div`
    display: flex;
    font-size: 16px;
`;

const RadioOptionContainer = styled.div`
    padding-right: 16px;

    img {
        margin: 4px;
        vertical-align: middle;
    }
`;

const Feedback = styled.div`
    margin-top: 8px;
`;

const Label = styled.span`
    font-size: 16px;
    font-weight: 600;
`;

const Index = styled.div`
    font-size: 16px;
    font-weight: 600;
    padding: 28px 16px 0 0;
`;

const Solution = styled.div`
    padding-top: 8px;
    display: flex;
    flex-direction: column;
`;

const Header = styled(FluidContainer)`
    margin: 0 0 0 34px;
    ${(props) => props.theme.mediaQueries.desktop} {
        margin: 0 0 0 32px;
    }
    flex-grow: 0;
`;

export const getLabel = (answered, answerType, solution, feedback) => {
    if (solution) {
        if (feedback) {
            return 'Feedback specifico. ';
        }
        return '';
    }
    if (!answered) {
        return 'Risposta non data. ';
    }
    if (answerType === HIGHLIGHT_SUCCESS) {
        return 'Risposta esatta. ';
    }
    if (answerType === HIGHLIGHT_ERROR) {
        return 'Risposta sbagliata. ';
    }
    return;
};

const SingleChoiceCorrection = ({ answers, exercise, solution }) => {
    const correctAnswer = exercise.options.find((item) => item.correct);
    const correctAnswerIndex = exercise.options.indexOf(correctAnswer);

    return (
        <FluidContainer flexDirection="column">
            <Header flexDirection="column">
                {exercise.prompt && <MathContent>{exercise.prompt}</MathContent>}
                {exercise.question && <MathContent>{exercise.question}</MathContent>}
            </Header>
            {exercise.options.map((option, index) => {
                const answered = answers && parseInt(answers.answer) === option.id;
                const answerType =
                    correctAnswer.id === option.id
                        ? HIGHLIGHT_SUCCESS
                        : answered && correctAnswer.id !== option.id
                          ? HIGHLIGHT_ERROR
                          : HIGHLIGHT_NORMAL;
                const correct = correctAnswer.id === option.id;

                return (
                    <SingleAnswerContainer key={index}>
                        <Index>{`${getCharByElementPosition(index + 1)}.`}</Index>
                        <RadioOptionContainer>
                            <Spacer size="base" />
                            <RadioOptionBox>
                                <RadioOption
                                    id={exercise.id}
                                    disabled={true}
                                    highlight={answerType}
                                    selected={answered}
                                    checked={answered || correct}
                                    value={index}
                                >
                                    {option.text}
                                </RadioOption>
                            </RadioOptionBox>
                            <Show when={(answerType !== HIGHLIGHT_NORMAL && !solution) || (solution && option.feedback)}>
                                <Feedback>
                                    <Label>{getLabel(answered, answerType, solution, option.feedback)}</Label>
                                    <MathContent style={{ display: 'inline' }}>{option.feedback}</MathContent>
                                </Feedback>
                            </Show>
                            {answerType === HIGHLIGHT_ERROR && (
                                <Solution>
                                    <Label>{`La risposta esatta è: ${getCharByElementPosition(correctAnswerIndex + 1)}`}</Label>
                                    <div style={{ paddingTop: '8px' }}>
                                        <ChoiceChip type="validated" value={correctAnswer.text} disabled={true} validationType="missing" />
                                    </div>
                                </Solution>
                            )}
                        </RadioOptionContainer>
                    </SingleAnswerContainer>
                );
            })}
        </FluidContainer>
    );
};
SingleChoiceCorrection.propTypes = exercisePropTypes.propTypes;

export default SingleChoiceCorrection;
